module.exports = __webpack_public_path__ + "fonts/Austin-Italic.50c4f6e0.otf";